export const scrollTo = (elementId: string, offset: number, behavior: ScrollBehavior = 'smooth') => {
  const scrollElement = document.getElementById(elementId);
  if (!scrollElement) {
    return;
  }

  scrollElement.scrollTo({
    top: offset,
    behavior,
  });
};
